module.exports = "<div>\n  <app-new-page [pageTitle]=\"page.title\" [pageSlug]=\"page.slug\"></app-new-page>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/event/about-us/about-us.component.html
// module id = ../../../../../src/app/event/about-us/about-us.component.html
// module chunks = main